var React = require('react');

function NoteMobile (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6.5 2h11a1 1 0 011 1v18a1 1 0 01-1 1h-11a1 1 0 01-1-1V3a1 1 0 011-1zM12 21a1 1 0 100-2 1 1 0 000 2zM7 4a.5.5 0 01.5-.5h9a.5.5 0 01.5.5v14a.5.5 0 01-.5.5h-9A.5.5 0 017 18V4z","fill":"currentColor"}));
}

NoteMobile.defaultProps = {"width":"24","height":"24","viewBox":"4 4 16 15","fill":"none"};

module.exports = NoteMobile;

NoteMobile.default = NoteMobile;
